import PropTypes from 'prop-types';
import React from 'react';
import { observer } from 'mobx-react';

import PureButton from 'ui/components/pure-controls/PureButton';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@wui/basics/typography';
import Icon from '@material-ui/core/Icon';
import SectionDocuments from 'ui/sections/documents/SectionDocuments';
import { useGlobalContext, useDocumentTitle } from 'hooks';

const KBALocked = ({ title }) => {
  useDocumentTitle(title);
  const { history } = useGlobalContext();
  const redirect = () => history.push(SectionDocuments.reviewUrl);

  return (
    <div className="card-wrapper">
      <div className="card">
        <div className="wizard-page">
          <Grid container spacing={1} className="kba__container">
            <Grid item xs={2}></Grid>
            <Grid item container xs={2} style={{ justifyContent: 'center' }}>
              <div className="kba__icon__locked " />
            </Grid>
            <Grid item container xs={6}>
              <h1 className="kba__title">
                Sorry, we are unable to continue with online notarization.{' '}
              </h1>
              <p className="kba__text">
                We are unable to verify your identity. The information provided does not match the
                available authentication information.
              </p>
              <Box className="kba__warning__box">
                <Icon className="kba__warning">warning</Icon>
                <Typography className="kba__text">
                  Identity verification has been <strong>locked for 48 hours</strong> due to
                  multiple failed attempts.
                </Typography>
              </Box>
              <p className="kba__text">
                You can return to verify your identity after 48 hours or return back to your
                documents at anytime to download and notarize in person.
              </p>
              <PureButton onClick={redirect} className="button--primary kba__button">
                Back to my documents
              </PureButton>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={1}></Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

KBALocked.url = '/kba-locked/';

KBALocked.propTypes = {
  title: PropTypes.string,
};
export default observer(KBALocked);
